import { createSelector } from 'reselect';
import LabelFormat from '~/types/LabelFormat';
import PackingSlipFormat from '~/types/PackingSlipFormat';
import { ApplicationState } from '../store';

export const getLabelSettingsStore = (state: ApplicationState) => state.labelSettings;

export const isLoadingLabelSettings = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.isLoadingLabelSettings,
);

export const isLoadedLabelSettings = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.isLoadedLabelSettings,
);

export const getLabelLogoType = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.data.labelLogoType,
);

export const getDefaultPackingSlipFormat = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore): PackingSlipFormat =>
    labelSettingsStore.data.defaultPackingSlipFormat || PackingSlipFormat.PSLIP_8X11_PDF,
);

export const getDefaultLabelFormat = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore): LabelFormat => labelSettingsStore.data.defaultLabelFormat,
);

export const getLabelSettings = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.data,
);
